"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustLightness = adjustLightness;
var color_1 = require("../../color");
var conversions_1 = require("../../conversions");
/**
 * Adjusts the lightness of a color.
 * @param color - The color to adjust.
 * @param amount - The amount to adjust by, from -100 to 100.
 * @returns A new Color instance with adjusted lightness.
 */
function adjustLightness(color, amount) {
    var hsl = color.toHsl();
    var newLightness = Math.max(0, Math.min(100, hsl.l + amount));
    var newRgb = (0, conversions_1.hslToRgb)(__assign(__assign({}, hsl), { l: newLightness }));
    return new color_1.Color(newRgb);
}
